<template>
  <div style="position:absolute;left:0;top:0;">
    <el-button style="width:100%;margin-bottom:5px;" type="primary" @click="to_edit_user">Add User</el-button>
    <div style="position:relative;width:300px;border:1px solid #dfdfdf;box-sizing:border-box;min-height: 100px;" v-loading="loading">
      <el-collapse accordion v-model="$store.state.email.slide_folder_accounts">
        <el-collapse-item v-for="(account, index_account) in $store.state.email.email_folders" :key="index_account" :name="account.display_name">
          <template slot="title">
            <b style="padding:14px;box-sizing:border-box;">{{account.display_name}}</b>
            <i class="el-icon-edit" style="margin-left:10px;margin-right:10px;" @click.stop="to_edit_user(account)"></i>
            <i class="el-icon-refresh" style="margin-right:10px;" @click.stop="to_sync(account)"></i>
            <i class="el-icon-s-promotion" @click.stop="to_send(account)"></i>
          </template>
          <div>
            <ul>
              <li 
                v-for="(folder, index_folder) in account.folders" 
                :key="index_folder" 
                @click="switch_folder(account, folder.label_id)" 
                :class="['folder-rows-li', (folder.label_id == account.checked_label_id) ? 'current' : '']">
                <span>{{folder.label_name}}</span>
                <span style="position:absolute;top:14px;right:14px;"><b>{{folder.unread}}</b>/<span>{{ folder.count }}</span></span>
              </li>
            </ul>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div style="position:relative;width:300px;border:1px solid #dfdfdf;box-sizing:border-box;padding:10px;">
      <span class="pointer" @click="redirect('/email/templates')">Templates</span>
    </div>
    <component :is="activeName" :item="editItem" :account="editItem"></component>
  </div>
</template>
<script>
const edit_users = resolve => require(['@/pages/email/_edit_users'], resolve);  
const pop_compose = resolve => require(['@/pages/email/_pop_compose'], resolve);  

export default {
  components: {
    edit_users,pop_compose
  },
  props: {
    is_index_page: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      activeName: null,
      editItem:null,
      slide_folder_accounts: [],
      folders: [],
    };
  },
  methods: {
    to_send(account) { 
      this.editItem = account;
      this.activeName = 'pop_compose'
    },
    to_edit_user(row = null){
      if (row) {
        this.editItem = row
      }
      this.activeName = 'edit_users'
    },
    to_sync(row) { 
      this.loading = true;
      this.$http
        .post("/v1/pri/store-email/sync-email", {mailbox_email:row.mailbox_email})
        .then((response) => {
          this.loading = false;
          var res = response.data;
          if (res.code == 1) {
            location = location
          }
        });
    },
    switch_folder(account, label_id) {
      if (!this.is_index_page) { 
        this.redirect('/email?label_id=' + label_id + "&mailbox_email=" + account.mailbox_email + "&slide_folder_account=" + account.display_name)
        return;
      }
      account.checked_label_id = label_id;
      this.$emit('get_messages_from_left', {label_id:label_id, mailbox_email:account.mailbox_email});
    },
    get_folders() {
      // this.$store.dispatch("get_email_folders");
      // this.loading = true;
      // this.$http
      //   .post("/v1/pri/store-email/folders", {})
      //   .then((response) => {
      //     this.loading = false;
      //     var res = response.data;
      //     if (res.code == 1) {
      //       this.folders = res.data
      //       this.slide_folder_accounts = [(slide_folder_account && slide_folder_account != 'null') ? slide_folder_account : this.folders[0].display_name]
      //       if (!label_id || label_id == 'null') label_id = 'INBOX';
      //       if (label_id) { 
      //         for (var i = 0; i < this.folders.length; i++) { 
      //           if (this.folders[i].display_name == slide_folder_account) { 
      //             this.folders[i].checked_label_id = label_id;
      //             break;
      //           }
      //         }
      //       }
      //       if (this.is_index_page) { 
      //         this.switch_folder(this.folders[0], "INBOX")
      //       }
      //     }
      //   });
    },
  },
}
</script>
<style scoped>
.folder-rows-li{position:relative;width:100%;padding:10px;padding-left:25px;box-sizing:border-box;cursor:pointer;}
.folder-rows-li:hover{background: #dfdfdf;}
.folder-rows-li.current{background: #dfdfdf;}
</style>


// WEBPACK FOOTER //
// src/pages/email/_left.vue